import { Flag } from '../../../scheduleMaintenance/flags/interfaces/Flag';

export const INITIAL_VALUES: Flag = {
  flag: '',
};
